import type { MeDto } from '@hudhuria/shared';
import { session } from '~/session/session';

/** Where signing in starts: the staff list on a front-desk device, the email form elsewhere. */
export const signInPath = (): '/desk' | '/sign-in' => (session.get().desk ? '/desk' : '/sign-in');

/** Where to send someone after the splash / a successful sign-in. */
export function entryPath(me?: MeDto): '/welcome' | '/sign-in' | '/desk' | '/center' | '/hub' {
  const s = session.get();
  if (!s.token) return s.desk ? '/desk' : s.onboarded ? '/sign-in' : '/welcome';
  if (me && session.needsCenter(me)) return '/center';
  return '/hub';
}
